<template>
    <iframe src="https://harnessgiving.com/dashboard/help-center" width="100%" class="container-height" style="border: 0;padding: 0;margin: 0">
    </iframe>
</template>

<script>
  export default {
    name: 'Help Center',
    metaInfo: {
      title: 'Help Center',
    },
  };
</script>

